import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { Link } from "react-router-dom";

export default function ProblemGear() {
	const [gear, setGear] = useState({
		needsRepair: {},
		missing: {},
		inUse: {},
	}); // + inUse
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		async function loadProblemGear() {
			const { data, error } = await supabase
				.from("gear")
				.select(
					"id, name, notes, case_id, cases(name, kit_cases(kits(name, color, id))) , gear_statuses(label)"
				)

				.in("gear_statuses.label", [
					"Needs Repair",
					"Missing",
					"In Use",
				]);

			if (error) {
				console.error("Error loading gear:", error);
				setLoading(false);
				return;
			}

			const groupByCase = (items) => {
				const grouped = {};
				for (const item of items) {
					const caseId = item.case_id;
					if (!grouped[caseId]) {
						grouped[caseId] = {
							caseName: item.cases?.name || "Unknown Case",
							items: [],
						};
					}
					grouped[caseId].items.push(item);
				}
				return grouped;
			};

			const needsRepair = groupByCase(
				data.filter(
					(item) => item.gear_statuses?.label === "Needs Repair"
				)
			);
			const missing = groupByCase(
				data.filter((item) => item.gear_statuses?.label === "Missing")
			);
			const inUse = groupByCase(
				data.filter((item) => item.gear_statuses?.label === "In Use")
			);

			setGear({ needsRepair, missing, inUse });
			setLoading(false);
		}

		loadProblemGear();
	}, []);

	if (loading) {
		return (
			<div className="loading">
				<div>
					<i className="pi pi-spin pi-spinner"></i>
				</div>
			</div>
		);
	}

	const renderGroupedGear = (groupedGear) => {
		const caseIds = Object.keys(groupedGear);
		if (caseIds.length === 0) return <p>No gear in this category.</p>;

		return caseIds.map((caseId) => {
			const group = groupedGear[caseId];
			const kits =
				group.items[0]?.cases?.kit_cases
					?.map((kc) => kc.kits)
					.filter(Boolean) ?? [];

			return (
				<div className="problem-item" key={caseId}>
					<h3>
						<Link to={`/cases/${caseId}`}>{group.caseName}</Link>
					</h3>

					{/* Render kit list if present */}
					{kits.length > 0 && (
						<div className="pill-wrapper">
							{kits.map(({ name, color, id }, idx) => (
								<div className="pill" key={idx}>
									{color && (
										<span
											className="color"
											style={{ backgroundColor: color }}
										></span>
									)}
									<Link to={`/kits/${id}`}>{name}</Link>
								</div>
							))}
						</div>
					)}

					<div>
						{group.items.map((item) => (
							<div key={item.id}>
								<strong>{item.name}</strong>
								{item.notes && <> – {item.notes}</>}
							</div>
						))}
					</div>
				</div>
			);
		});
	};

	return (
		<div className="main">
			<h1>Problem Gear</h1>

			<div className="problem-box">
				<h2>
					In Use <i className="pi pi-ban icon-inuse"></i>
				</h2>
				<div className="problem-box__item-wrapper">
					{renderGroupedGear(gear.inUse)}
				</div>
			</div>

			<div className="problem-box">
				<h2>
					Needs Repair <i className="pi pi-wrench icon-repair"></i>
				</h2>
				<div className="problem-box__item-wrapper">
					{renderGroupedGear(gear.needsRepair)}
				</div>
			</div>

			<div className="problem-box">
				<h2>
					Missing{" "}
					<i className="pi pi-exclamation-triangle icon-missing"></i>
				</h2>
				<div className="problem-box__item-wrapper">
					{renderGroupedGear(gear.missing)}
				</div>
			</div>
		</div>
	);
}
